var escape = require("../../../css-loader/lib/url/escape.js");
exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-login-container{display:flex;width:100%;height:100vh;justify-content:flex-end;align-items:center;background-image:url(" + escape(require("../assets/images/login_page_image.jpg")) + ");background-repeat:no-repeat;background-attachment:fixed;background-size:cover}.cap-login-card{width:25rem;padding:4rem 2rem;border-radius:.5rem;margin-right:4rem}.cap-login-logo{width:3rem;height:auto}.cap-login-heading{padding:1.25rem 0;letter-spacing:1px;word-spacing:2px}.cap-login-input{margin-bottom:1rem}.cap-login-centeringDiv{display:flex;align-items:center;flex-direction:column}.cap-login-button{width:50%;margin-top:1.25rem}\n", ""]);

// exports
